import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_FILTER_GROUP,
  FilterGroup,
  FilterGroupPayload,
} from './filterGroup.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getFilterGroupList(): AxiosPromise<ServerResponse<FilterGroup>> {
  return http.get(`${API_PATH_FILTER_GROUP}`);
}

export function getFilterGroup(
  id: string,
): AxiosPromise<ServerResponse<FilterGroup>> {
  return http.get(`${API_PATH_FILTER_GROUP}/${id}`);
}

export function createFilterGroup(
  body: WithAuditDetails<FilterGroup>,
): AxiosPromise<ServerResponse<FilterGroup>> {
  return http.post(`${API_PATH_FILTER_GROUP}`, body);
}

export function updateFilterGroup(
  id: string,
  body: WithAuditDetails<FilterGroupPayload>,
): AxiosPromise<ServerResponse<FilterGroup>> {
  return http.put(`${API_PATH_FILTER_GROUP}/${id}`, body);
}

export function deleteFilterGroup(
  id: string,
  name: string,
): AxiosPromise<ServerResponse<FilterGroup>> {
  return http.delete(`${API_PATH_FILTER_GROUP}/${id}?name=${encodeURIComponent(name)}`);
}
